<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // 派发一个action||获取菜单列表的数据
    this.$store.dispatch("getCategoryList");
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue